export default {
  name: "currencies-auto-complete",
  components: {},
  // props: ["list", "selected", "isDisabled"],
  props: {
    list: {
      type: Array
    },
    selected: {
      type: Object
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      search: ""
    };
  },
  computed: {
    filterResult() {
      if (this.list) {
        return this.list.filter(elem => {
          return (
            elem.name_locale
              .replace(/[^\p{L}]/gu, "")
              .includes(this.search.toLowerCase().replace(/[^\p{L}]/gu, "")) ||
            elem.name
              .replace(/[^\p{L}]/gu, "")
              .toLowerCase()
              .includes(this.search.toLowerCase().replace(/[^\p{L}]/gu, "")) ||
            elem.iso
              .replace(/[^\p{L}]/gu, "")
              .toLowerCase()
              .includes(this.search.toLowerCase().replace(/[^\p{L}]/gu, ""))
          );
        });
      }
    }
  },
  mounted() {},
  methods: {
    handleChange(value) {
      this.$emit("change", value);
    },
    handleSearch() {
      this.search = "";
    }
  }
};
